var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.971 17.286 C 7.239 17.286 7.475 17.192 7.768 17.023 L 15.3 12.74 C 15.848 12.426 16.078 12.182 16.078 11.786 C 16.078 11.391 15.848 11.153 15.3 10.833 L 7.768 6.55 C 7.475 6.381 7.239 6.286 6.971 6.286 C 6.448 6.286 6.078 6.682 6.078 7.302 L 6.078 16.271 C 6.078 16.898 6.448 17.286 6.971 17.286 Z M 7.443 15.731 C 7.411 15.731 7.385 15.7 7.385 15.656 L 7.385 7.917 C 7.385 7.867 7.411 7.842 7.443 7.842 C 7.468 7.842 7.494 7.854 7.519 7.873 L 14.292 11.717 C 14.318 11.736 14.343 11.755 14.343 11.786 C 14.343 11.818 14.318 11.837 14.292 11.855 L 7.519 15.7 C 7.494 15.719 7.468 15.731 7.443 15.731 Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.755d75f319a078293e10dccb30d062e3.svg";
export { ForwardRef as ReactComponent };